import { Collapse, Grid } from '@mui/material';
import React from 'react';
import DOMPurify from 'dompurify';

export function Alerts ({ open, alertMessage }) {

    const sanitizedAlert = () => ({
        __html: DOMPurify.sanitize(alertMessage),
    });

    return (
        <>
            {alertMessage &&
                <Grid container>
                    <div style={{width:"100%"}}>
                        <Collapse in={open} style={{ backgroundColor: "#E5E7E6" }} aria-expanded={open}>
                            <Grid style={{display: "flex"}}>
                                <Grid style={{ maxWidth: "1200px", marginLeft: "auto", marginRight: "auto", padding: "0px 25px 0px 25px" }}>
                                    <div dangerouslySetInnerHTML={sanitizedAlert()} style={{ fontSize: "15px" }} />
                                </Grid>
                            </Grid>
                        </Collapse>
                    </div>
                </Grid>
            }
        </>
    );
}